<div class="mention-wrapper">

  <!-- Textarea -->
  <div class="textarea-container">
    <textarea
      class="mention-textarea"
      [rows]="rows"
      [placeholder]="placeholder"
      [value]="text"
      (input)="onInput($event)"
      (keydown)="onKeyDown($event)"
      (blur)="onTouched()"
      #textareaRef>
    </textarea>

    <!-- @mention dropdown -->
    <div *ngIf="showDropdown && filteredUsers.length > 0" class="mention-dropdown">
      <div
        *ngFor="let user of filteredUsers"
        class="mention-option"
        (mousedown)="selectUser(user, textareaRef)">
        <div class="mention-avatar">{{ user.name[0].toUpperCase() }}</div>
        <div class="mention-info">
          <span class="mention-name">{{ user.name }}</span>
          <span class="mention-email">{{ user.email }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Mentioned chips -->
  <div *ngIf="mentionedUsers.length > 0" class="mentioned-chips">
    <span class="chips-label">Mentioned:</span>
    <span *ngFor="let user of mentionedUsers" class="mention-chip">
      <mat-icon class="chip-icon">alternate_email</mat-icon>
      {{ user.name }}
      <mat-icon class="remove-icon" (click)="removeMention(user)">close</mat-icon>
    </span>
  </div>

</div>
